/* ba-slider : chargement reellement paresseux des images avant/apres.

   Probleme : le rail est un scroller horizontal. Les cartes hors ecran a droite
   restent dans le viewport vertical, et loading="lazy" natif les telecharge
   quand meme des que la section approche (22 images pour 2 visibles).

   Solution, calquee sur assets/video-row-lazy.js : la balise Liquid emet
   data-ba-src / data-ba-srcset au lieu de src / srcset, aucune requete n'est
   donc declenchee par l'analyseur HTML. Un IntersectionObserver rattache la
   source quand la carte approche du viewport, en observant aussi le
   defilement horizontal du rail.

   Le srcset, le sizes, les dimensions et le rendu sont strictement ceux
   produits par Liquid : seule la date de la requete change.
   Sans JavaScript, le <noscript> du bloc affiche les images normalement. */
(function () {
  if (window.__baLazy) return;
  window.__baLazy = true;

  var SELECTOR = 'img[data-ba-src], img[data-ba-srcset]';
  var MARGIN = '400px'; /* couvre la carte suivante dans les deux axes */

  function hydrate(img) {
    if (!img || img.__baDone) return;
    img.__baDone = true;
    var srcset = img.getAttribute('data-ba-srcset');
    var src = img.getAttribute('data-ba-src');
    /* srcset avant src : le selecteur de source doit connaitre les candidats
       avant que src ne devienne un candidat de repli. */
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-ba-srcset');
    }
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-ba-src');
    }
  }

  function hydrateAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) hydrate(nodes[i]);
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var el = entries[i].target;
          hydrate(el);
          observer.unobserve(el);
        }
      },
      { root: null, rootMargin: MARGIN, threshold: 0 }
    );
  }

  function observe(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var img = nodes[i];
      if (img.getAttribute('data-ba-observed') === '1') continue;
      img.setAttribute('data-ba-observed', '1');
      if (observer) observer.observe(img);
      else hydrate(img); /* repli : navigateurs sans IntersectionObserver */
    }
  }

  function boot() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Filets de securite : une image ne doit jamais rester sans source.
     - impression : le contenu hors ecran doit sortir sur le papier
     - recherche dans la page / ancre : rien ne doit rester vide durablement */
  window.addEventListener('beforeprint', function () {
    hydrateAll(document);
  });

  /* editeur de theme : les sections/blocs re-rendus doivent etre re-observes */
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    hydrateAll(e.target);
    observe(e.target);
  });

  window.__baLazyHydrateAll = hydrateAll;
})();
